var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSquare42BError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2,
  d: "M50 48.5a1.5 1.5 0 0 1-1.5 1.5h-19a1.5 1.5 0 0 1-1.5-1.5v-19a1.5 1.5 0 0 1 1.5-1.5h19a1.5 1.5 0 0 1 1.5 1.5v19Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M38.5 16.5A2.5 2.5 0 0 1 36 19H24.5a2.5 2.5 0 0 1-2.5-2.5v-10A2.5 2.5 0 0 1 24.5 4h14v12.5ZM16.5 39.5A2.5 2.5 0 0 1 19 42v11.5a2.5 2.5 0 0 1-2.5 2.5h-10A2.5 2.5 0 0 1 4 53.5v-14h12.5ZM56 16.5a2.5 2.5 0 0 1-2.5 2.5H42a2.5 2.5 0 0 1-2.5-2.5V4h14A2.5 2.5 0 0 1 56 6.5v10ZM16.5 22a2.5 2.5 0 0 1 2.5 2.5V36a2.5 2.5 0 0 1-2.5 2.5H4v-14A2.5 2.5 0 0 1 6.5 22h10Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M56 14V6.5A2.5 2.5 0 0 0 53.5 4h-29A2.5 2.5 0 0 0 22 6.5V14M14 22H6.5A2.5 2.5 0 0 0 4 24.5v29A2.5 2.5 0 0 0 6.5 56H14"
})));
SvgSquare42BError.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgSquare42BError);
export default ForwardRef;